// extracted by mini-css-extract-plugin
module.exports = {"primary":"#0d4f9d","secondary":"#ff1744","paper":"Profile_paper__11svp","form":"Profile_form__1SuTI","button":"Profile_button__1mTCs"};